import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "../axiosInstance";

export interface OtherBranchData {
    special: boolean;
    customer_name: string;
    customer_manager_name: string;
    customer_manager_mobile: string;
    order_count: number;
    order_amount: number;
    pending_count: number;
    payment_complete_count: number;
    payment_date: string;
    payment_amount: number;
    pending_amount: number;
    customer_branch_idx: number;
    branch_payment_status: number;
    branch_payment_status_text: string;
}

interface GetOtherBranchResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: OtherBranchData[];
}

interface GetOtherBranchParams {
    page: number;
    limit: number;
    searchtxt?: string;
    field?: string;
    direction?: string;
    status?: number;
}

export const useGetOtherBranchList = (params: GetOtherBranchParams): UseQueryResult<GetOtherBranchResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetOtherBranchResponse, Error>({
        queryKey: ["getOtherBranchList", params],
        queryFn: async () => {
            const response = await axiosInstance.get(`${enum_api_uri.get_settlements}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    page: params.page,
                    limit: params.limit,
                    search: "customer_name",
                    searchtxt: params.searchtxt,
                    field: params.field,
                    direction: params.direction,
                    ...(params.status === 1 ? { branch_payment_status: params.status } : {}),
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: params.page,
                };
            }
            return undefined;
        },
    });
};
